import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import { copyToClipboard } from '@ipfabric/ui-components/utils/copyToClipboard';
import { Button } from 'components/Button/Button';
import { useLocale } from 'containers/App/LocaleContext';
import type { FC } from 'react';
import ReactMarkdown from 'react-markdown';
import { apiEndpointToFullUrl } from 'utils/apiEndpointToFullUrl';
import { useNotifications } from 'utils/hooks/useNotifications';
import { deviceAttributesDocs } from './deviceAttributesDocs';

export const DeviceAttributesWriteApiDoc: FC = () => {
  const {
    settings: {
      deviceAttributes: { docs: docsMsg },
    },
  } = useLocale();
  const { showNotification } = useNotifications();

  const handleCopyClick = (text: string) => {
    copyToClipboard(text);
    showNotification({
      type: 'success',
      message: docsMsg.copyToClipboardSuccess,
    });
  };

  const globalUrl = apiEndpointToFullUrl('/attributes/global');

  return (
    <>
      <h4 className='mt-0'>{docsMsg.setAttribute}</h4>
      <p>{docsMsg.setAttributeDescription}</p>
      <p>
        <strong>{docsMsg.url}</strong>
        {': '}
        <code>{globalUrl}</code>
        <Tooltip content={docsMsg.copyToClipboard}>
          <Button
            variant='tertiary'
            icon='fa-copy'
            size='xxs'
            onClick={() => {
              handleCopyClick(globalUrl);
            }}
            className='ml-1'
            type='button'
          />
        </Tooltip>
      </p>
      <ReactMarkdown>{deviceAttributesDocs.put}</ReactMarkdown>
      <h4>{docsMsg.deleteAttribute}</h4>
      <p>
        <strong>{docsMsg.url}</strong>
        {': '}
        <code>{globalUrl}</code>
        <Tooltip content={docsMsg.copyToClipboard}>
          <Button
            variant='tertiary'
            icon='fa-copy'
            size='xxs'
            onClick={() => {
              handleCopyClick(globalUrl);
            }}
            className='ml-1'
            type='button'
          />
        </Tooltip>
      </p>
      <ReactMarkdown>{deviceAttributesDocs.delete}</ReactMarkdown>
    </>
  );
};
